import React from "react";
import { useDispatch } from "react-redux";

import { changePassword } from "Auth/state";
import { AUTH_ACTIONS, IChangePassword } from "Auth/types";
import { ChangePassword as ChangePasswordComponent } from "Auth/components";

interface ChangePasswordProps {
  handleClose: () => void;
}

export const ChangePassword: React.FC<ChangePasswordProps> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const onSubmit = ({ oldPassword, newPassword }: IChangePassword) => {
    dispatch(changePassword({ oldPassword, newPassword }));
  };

  return (
    <ChangePasswordComponent
      handleClose={handleClose}
      onSubmit={onSubmit}
      metaKey={AUTH_ACTIONS.changePassword}
    />
  );
};
